import Vue from 'vue'
import Router from 'vue-router'
import Membresias from '../components/Membresias/Membresias'
import Miembros from '../components/Miembros/Miembros'
import EditarMiembro from '../components/Miembros/EditarMiembro'
import Usuarios from '../components/Usuarios/Usuarios'
import NuevoMiembro from '../components/Miembros/NuevoMiembro'
import NuevoUsuario from '../components/Usuarios/NuevoUsuario'
import EditarUsuario from '../components/Usuarios/EditarUsuario'
import CambiarPassword from '../components/Usuarios/CambiarPassword'
import Pagos from '../components/Pagos/Pagos'
import RegistrarVisita from '../components/Visitas/RegistrarVisita'
import Visitas from '../components/Visitas/Visitas'
import ConfiguracionComponent from '../components/Configuracion/ConfiguracionComponent'
import InicioComponent from '../components/InicioComponent'
import MiPerfil from '../components/Usuarios/MiPerfil'
import AlertasComponent from '../components/Alertas/AlertasComponent'
import ReportesComponent from '../components/Reportes/ReportesComponent'
import HistorialMiembro from '../components/Miembros/HistorialMiembro'
import EscanerPage from '../components/EscanerPage'

Vue.use(Router)

function estaAutenticado() {
  return !!localStorage.getItem('jwt_token')
}

function obtenerRol() {
  return localStorage.getItem('rolUsuario') || 'recepcionista'
}

const router = new Router({
  routes: [
    { path: '/',                  name: 'InicioComponent',  component: InicioComponent,       meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/membresias',        name: 'Membresias',       component: Membresias,            meta: { requiresAuth: true,  roles: ['admin'] } },
    { path: '/miembros',          name: 'Miembros',         component: Miembros,              meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/nuevo-miembro',     name: 'NuevoMiembro',     component: NuevoMiembro,          meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/editar-miembro/:id',name: 'EditarMiembro',    component: EditarMiembro,         meta: { requiresAuth: true,  roles: ['admin','recepcionista'] } },
    { path: '/miembro/:id/historial', name: 'HistorialMiembro', component: HistorialMiembro,  meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/usuarios',          name: 'Usuarios',         component: Usuarios,             meta: { requiresAuth: true,  roles: ['admin'] } },
    { path: '/nuevo-usuario',     name: 'NuevoUsuario',     component: NuevoUsuario,         meta: { requiresAuth: true,  roles: ['admin'] } },
    { path: '/editar-usuario/:id',name: 'EditarUsuario',    component: EditarUsuario,        meta: { requiresAuth: true,  roles: ['admin'] } },
    { path: '/cambiar-password',  name: 'CambiarPassword',  component: CambiarPassword,      meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/pagos',             name: 'Pagos',            component: Pagos,                meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/registrar-visita',  name: 'RegistrarVisita',  component: RegistrarVisita,      meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/visitas',           name: 'Visitas',          component: Visitas,              meta: { requiresAuth: true,  roles: ['admin','recepcionista'] } },
    { path: '/configurar',        name: 'Configurar',       component: ConfiguracionComponent,meta: { requiresAuth: true, roles: ['admin'] } },
    { path: '/perfil',            name: 'MiPerfil',         component: MiPerfil,             meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/alertas',           name: 'Alertas',          component: AlertasComponent,     meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
    { path: '/reportes',          name: 'Reportes',         component: ReportesComponent,    meta: { requiresAuth: true,  roles: ['admin'] } },
    { path: '/escanear-qr',       name: 'EscanerQR',        component: EscanerPage,          meta: { requiresAuth: true,  roles: ['admin','recepcionista','entrenador'] } },
  ],
})

// ── Guard de navegación ───────────────────────────────────────────────────────
// IMPORTANTE: NO usar window.location.reload() aquí — causaría loop infinito.
// El login se maneja con v-if en App.vue, no con una ruta separada.
router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) { next(); return }

  if (!estaAutenticado()) {
    // Detener la navegación — App.vue mostrará el Login via v-if="!logeado"
    next(false)
    return
  }

  const rolActual = obtenerRol()
  const rolesPermitidos = to.meta.roles || ['admin']
  if (!rolesPermitidos.includes(rolActual)) {
    next({ name: 'InicioComponent' })
    return
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js